import { ReactNode, ButtonHTMLAttributes, Ref } from 'react';
import classNames from 'classnames';

import styles from './Button.module.scss';

type ButtonVariant = 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'text';

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
    children: ReactNode;
    variant?: ButtonVariant;
    leadingIcon?: ReactNode;
    trailingIcon?: ReactNode;
    disabled?: boolean;
    ref?: Ref<HTMLButtonElement>;
};

const Button =
    ({ children, variant = 'primary', leadingIcon, trailingIcon, disabled, ref, ...props }: ButtonProps) => {
    	return (
    		<button
    			ref={ref}
    			className={classNames(styles.button, styles[variant], { [styles.disabled]: disabled })}
    			disabled={disabled}
    			{...props}
    		>
    			{leadingIcon && <span className={styles.icon}>{leadingIcon}</span>}
    			<span className={styles.label}>{children}</span>
    			{trailingIcon && <span className={styles.icon}>{trailingIcon}</span>}
    		</button>
    	);
    };

export default Button;
